import { NavLink } from 'react-router-dom'
import { useAuth } from '../auth/useAuth'
import { can } from '../auth/AuthContext'
import { BbIcon } from './BbIcon'
import type { BbIconName } from './BbIcon'

/* Icon rail from "prototypes/BatchBooks Import - Select Type".

   Two deliberate departures from that prototype, both requested 2026-08-31:
   the collapse toggle sits above the nav list rather than at the foot, and
   Settings has moved out of the rail into the TopBar profile menu (it pointed
   at the same /app/settings route the menu already offered).

   Each entry is capability-gated the same way its route is in App.tsx, so the
   rail never offers a destination that would bounce off RequireAuth. */

export interface SideNavItem {
  to: string
  label: string
  icon: BbIconName
  end?: boolean
  capability?: 'import' | 'export' | 'delete'
}

const ITEMS: SideNavItem[] = [
  { to: '/app', label: 'Dashboard', icon: 'dashboard', end: true },
  { to: '/app/import', label: 'Import', icon: 'upload', capability: 'import' },
  { to: '/app/export', label: 'Export', icon: 'download', capability: 'export' },
  { to: '/app/delete', label: 'Delete', icon: 'trash', capability: 'delete' },
  { to: '/app/jobs', label: 'Job history', icon: 'history' },
]

export function SideNav({ open, onToggle }: { open: boolean; onToggle: () => void }) {
  const { user } = useAuth()
  const items = ITEMS.filter((item) => !item.capability || can(user?.role, item.capability))

  return (
    <nav className={open ? 'bb bb-side bb-side-open' : 'bb bb-side'} aria-label="Sections">
      <button
        className="bb-side-toggle"
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        aria-label={open ? 'Collapse navigation' : 'Expand navigation'}
      >
        <BbIcon name="menu" />
      </button>

      <div className="bb-side-list">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => (isActive ? 'bb-side-i bb-on' : 'bb-side-i')}
            title={open ? undefined : item.label}
          >
            <BbIcon name={item.icon} />
            <span className="bb-side-label">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
